// extracted by mini-css-extract-plugin
export var callCard = "_qe-0";
export var callMessageButton = "_qe-1";
export var helpIcon = "_qe-3";
export var helpIconContainer = "_qe-4";
export var verticalDivider = "_qe-2";